import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=768cbe36"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768cbe36')) {
      api.createRecord('768cbe36', component.options)
    } else {
      api.reload('768cbe36', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=768cbe36", function () {
      api.rerender('768cbe36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Dashboard.vue"
export default component.exports